import { useOwnsFreeOrStarterPortal } from 'onboarding-scopes/monetization-utils';
import { useIsUngatedForIARedesign } from '../../../auth/hooks/useIsUngatedForIARedesign';
import { useQueryParams } from '../../../router/useQueryParams';
import { getOnboardingBeaconsSessionStorage } from '../utils/onboardingBeaconsLocalStorage';
import { CONTACT } from 'customer-data-objects/constants/ObjectTypes';
export const useShouldShowOnboardingBeacons = objectType => {
  const {
    showOnboardingBeacons
  } = useQueryParams();
  const isUngatedForIARedesign = useIsUngatedForIARedesign();
  const isFreeOrStarterPortal = useOwnsFreeOrStarterPortal();
  const isContactIndexPage = objectType === CONTACT;
  const enforceOnboardingBeacons = showOnboardingBeacons === 'true' || getOnboardingBeaconsSessionStorage();
  return !isUngatedForIARedesign && isFreeOrStarterPortal && isContactIndexPage || enforceOnboardingBeacons;
};